import { Outlet } from "react-router-dom";

const VendorsManagement = () => {
  return (
    <><Outlet /></>
  );
};

export default VendorsManagement;
